import React, { useEffect, useState, useRef } from 'react';
import { Button, Input, InputRed, LayerBottom, Toast, InputTimer, Layer } from 'components'
import useApp from 'hooks/useApp'
import { useNavigate, useLocation } from 'react-router-dom'
import { showMyInfoNumberCertState, userLogInfoState, showMemberEditLayerState, showMyInfoNumberState } from 'views/member/states'
import { useRecoilState, useSetRecoilState } from 'recoil'
import Lib from 'library'

const MyInfoNumberCert = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const location = useLocation()
	const navigate = useNavigate()

	const [showMyInfoNumberCert, setShowMyInfoNumberCert] = useRecoilState(showMyInfoNumberCertState)
	const [showMemberEditLayer, setShowMemberEditLayer] = useRecoilState(showMemberEditLayerState)
	const [showMyInfoNumber, setShowMyInfoNumber] = useRecoilState(showMyInfoNumberState)
	const [userInfo, setUserInfo] = useRecoilState(userLogInfoState)

	const [info, setInfo] = useState()
	const [showToast, setShowToast] = useState()
	const [buttonDisabled, setButtonDisabled] = useState(true)
	const [disabled, setDisabled] = useState(false)
	const [showRed, setShowRed] = useState(false)
	const [timerStart, setTimerStart] = useState(false) // 타이머 스타트 여부
	const [certTimout] = useState(180) // 인증번호 입력 시간 제한, 초
	const [certNumber, setCertNumber] = useState("")

	const input = useRef()

	// 인증번호 입력 시간 초과
	const onTimerComplete = () => {
		setShowRed(true)
		setCertNumber()
		setDisabled(true)

	}

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const sendCertNumber = () => {
		Lib.post({
			url: `/api/more/myinfo/auth/req`,
			data: {
				cphNo: info.cphNo,
				nm: info.nm,
				rsdtRegNo: info.rsdtRegNo,
				tcomCd: info.tcomCd
			},
			onSuccess: data => {
				window.setTimeout(() => {
					setShowToast(true)
				}, 300)
				setCertNumber("")
				setButtonDisabled(true)
				//input.current.focus()
				setTimerStart(true)
				setShowRed(false)
			},
			onError: error => {
				App.alert(`${error}`)
			}
		})
	}

	const resend = () => {
		sendCertNumber()
		setDisabled(false)
	}

	const onNext = () => {
		Lib.post({
			url: `/api/more/myinfo/auth/verify`,
			data: { authNo: certNumber },
			onSuccess: data => {
				saveMemberInfo()
				App.alert("수정 완료되었습니다")
				setShowMyInfoNumberCert(false)
				setShowMyInfoNumber(false)
			},
			onError: error => {
				App.alert("본인인증에 실패하였습니다")
			}
		})
	}
	//인증성공 후 정보 업데이트
	const saveMemberInfo = () => {
		Lib.post(`/api/more/myinfo/upd`, {
			cphNo: info.cphNo,
			mbId: App.user.mbId,
			mbNm: info.nm,
			tcomCd: info.tcomCd
		}, data => {
			console.log(data)
		})
	}

	// useEffect(() => {
	// 	if (info) {
	// 		sendCertNumber()
	// 	}
	// }, [info])

	useEffect(() => {
		setInfo(userInfo)
		// console.log(info)
		// console.log(userInfo)
		if (showMyInfoNumberCert) {
			setCertNumber("")
			window.setTimeout(() => {
				setShowToast(true)
			}, 300)
			setButtonDisabled(true)
			setTimerStart(true)
			setShowRed(false)
		}
	}, [showMyInfoNumberCert])


	return (
		<Layer show={showMyInfoNumberCert} closeLayer={() => setShowMyInfoNumberCert(false)}>
			<div className="page">
				<div className="flex_1 padding">
					<h3>휴대폰으로 전송된<br />인증번호 6자리를 입력해주세요.</h3>

					<p className="guide-title mt_40">인증번호</p>
					<div className="mt_10 relative flex-align_center">
						<Input ref={input} disabled={disabled} type="tel" placeholder="인증번호 입력" value={certNumber} className="mr_10 pr_5 withBtn" maxlength="6" onChange={e => {
							const value = e.target.value
							setCertNumber(value)
							if (e.target.value.length >= 6) {
								setButtonDisabled(false)
							} else {
								setButtonDisabled(true)
							}
						}} />
						<InputTimer start={timerStart} setStart={setTimerStart} duration={certTimout} onComplete={onTimerComplete} />
						<Button className="btn btn--sm btn--light-blue nowrap" style={{ fontSize: "1.2rem" }} onClick={resend}>재전송</Button>

					</div>

					{/* 오류메세지 출력 시 Input focus border 레드 컬러로 */}
					<InputRed text="인증번호 입력시간이 초과되었어요. 재전송을 통해 인증번호를 다시 받고 입력해주세요." show={showRed} />

					<p className="btn-text mt_20"><span onClick={openLayer}>인증번호가 오지 않나요?</span></p>
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big" disabled={buttonDisabled} onClick={onNext}>확인</Button>
				</div>

				<ConfirmLayer show={showLayer} closeLayer={closeLayer} />

				<Toast show={showToast} setShow={setShowToast} text="인증번호가 발송되었습니다." />
			</div>
		</Layer>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="인증번호가 오지 않나요?" show={show} closeLayer={closeLayer}>
			<div className="layer-text">
				<p>‘스팸차단 서비스’로 인증번호 수신이 어려울 수 있습니다.<br />
					전화 &gt; 더보기 &gt; 설정 &gt; 수신차단 목록에서 SMS 인증 발신번호를 제외 해주세요.</p>
				<p className="mt_20">통신사 ‘명의도용알림 서비스’로 인증번호 수신이 어려울 수 있습니다. 통신사에 직접 문의하여 해지해주세요.</p>
			</div>
		</LayerBottom>
	)
}

export default MyInfoNumberCert